import { component } from "picoapp";
import type { Splide } from "@splidejs/splide";

export const contentCardMarquee = component(async (node: HTMLElement) => {
  const [{ default: Splide }, { AutoScroll }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-auto-scroll"),
    import("@splidejs/splide/css/core"),
  ]);

  const desktopMarquee = node.querySelector<HTMLElement>(".desktop-marquee");
  const mobileMarqueeTop = node.querySelector<HTMLElement>(
    ".mobile-marquee-top"
  );
  const pauseButton = node.querySelector<HTMLElement>("[data-pause]");
  const playButton = node.querySelector<HTMLElement>("[data-play]");
  const buttonContainer =
    node.querySelector<HTMLButtonElement>(".play-pause-button");
  let isPlaying = true;
  if (!desktopMarquee || !mobileMarqueeTop || !pauseButton || !playButton)
    return;
  const mobileMarqueeBottom = node.querySelector<HTMLElement>(
    ".mobile-marquee-bottom"
  );
  const desktopSlides =
    desktopMarquee.querySelectorAll<HTMLElement>(".splide__slide");

  const desktopSlideWidth = desktopSlides[0].getBoundingClientRect().width;
  const desktopGap = 24;
  const desktopMarqueeSpeed =
    parseFloat(node.dataset.desktopSpeed ?? "0") || 0.8;
  const mobileMarqueeTopSpeed =
    parseFloat(node.dataset.mobileTopSpeed ?? "0") || 0.2;
  const mobileMarqueeBottomSpeed =
    parseFloat(node.dataset.mobileBottomSpeed ?? "0") || 0.2;

  new Splide(desktopMarquee, {
    type: "loop",
    drag: "free",
    gap: desktopGap,
    pagination: false,
    autoWidth: true,
    clones: Math.floor(
      node.getBoundingClientRect().width / (desktopSlideWidth + desktopGap)
    ),
    autoScroll: {
      speed: desktopMarqueeSpeed,
    },
  }).mount({ AutoScroll });

  const marqueeTop = new Splide(mobileMarqueeTop, {
    type: "loop",
    pagination: false,
    arrows: false,
    gap: 16,
    autoWidth: true,
    autoScroll: {
      speed: mobileMarqueeTopSpeed,
    },
  }).mount({ AutoScroll });

  let marqueeBottom: Splide | null = null;
  if (mobileMarqueeBottom) {
    marqueeBottom = new Splide(mobileMarqueeBottom, {
      type: "loop",
      pagination: false,
      arrows: false,
      gap: 16,
      autoWidth: true,
      autoScroll: {
        speed: mobileMarqueeBottomSpeed,
      },
    }).mount({ AutoScroll });
  }

  const showPlayButton = () => {
    pauseButton.style.display = "none";
    playButton.style.display = "block";
  };
  const showPauseButton = () => {
    playButton.style.display = "none";
    pauseButton.style.display = "block";
  };

  const pauseAnimation = () => {
    showPlayButton();
    marqueeTop.Components.AutoScroll?.pause();
    marqueeBottom?.Components.AutoScroll?.pause();
    isPlaying = false;
    playButton.focus();
  };

  const playAnimation = () => {
    showPauseButton();
    marqueeTop.Components.AutoScroll?.play();
    marqueeBottom?.Components.AutoScroll?.play();
    isPlaying = true;
    pauseButton.focus();
  };

  buttonContainer?.addEventListener("click", () => {
    if (isPlaying) {
      pauseAnimation();
    } else {
      playAnimation();
    }
  });

  return () => {
    pauseButton.removeEventListener("click", pauseAnimation);
    playButton.removeEventListener("click", playAnimation);
  };
});
